module.exports = __webpack_public_path__ + "img/3.8fbc3961.png";